import { Component, Pipe, PipeTransform } from '@angular/core';
import { map } from 'rxjs/operators';
import { PotentialRevenueService } from './potential-revenue.service';
import { getLocale } from '@vendasta/galaxy/utility/locale';
import { formatInTimeZone } from 'date-fns-tz';

@Component({
  selector: 'sales-ui-potential-revenue',
  templateUrl: './potential-revenue.component.html',
  styleUrls: ['./potential-revenue.component.scss'],
  standalone: false,
})
export class PotentialRevenueComponent {
  potentialRevenue$ = this.potentialRevenueService.potentialRevenue$;
  weightedPotentialRevenue$ = this.potentialRevenueService.weightedPotentialRevenue$;
  monthlyRevenue$ = this.potentialRevenueService.monthlyRevenue$;
  monthlyWeightedRevenue$ = this.potentialRevenueService.monthlyWeightedRevenue$;
  currency$ = this.potentialRevenueService.currency$;
  isPotentialRevenueLoaded$ = this.potentialRevenueService.isPotentialRevenueLoaded$;
  readonly selectedDate$ = this.potentialRevenueService.selectedDate$;
  showMonthlyRevenue$ = this.selectedDate$.pipe(map((date) => !!date));

  constructor(private readonly potentialRevenueService: PotentialRevenueService) {}
}

@Pipe({
  name: 'monthYear',
  standalone: false,
})
export class MonthYearPipe implements PipeTransform {
  transform(date: Date): string {
    if (!date) {
      return '';
    }

    return formatInTimeZone(date, 'UTC', 'MMMM yyyy', { locale: getLocale() });
  }
}
